import React from 'react';

const ExternalLink = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 40 40"
      role="graphics-symbol"
      aria-label="external link opens in new tab"
    >
      <polygon points="0 0 15 0 15 5 5 5 5 35 35 35 35 25 40 25 40 40 0 40 0 0" />
      <polygon points="21.05 0 40 0 40 18.95 32.9 11.84 22.24 22.5 17.5 17.76 28.16 7.11 21.05 0" />
    </svg>
  );
};

export default ExternalLink;
